import { render, staticRenderFns } from "./ImagesWidget.vue?vue&type=template&id=6d8309b8"
import script from "./ImagesWidget.vue?vue&type=script&lang=js"
export * from "./ImagesWidget.vue?vue&type=script&lang=js"
import style0 from "./ImagesWidget.vue?vue&type=style&index=0&id=6d8309b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports